module.exports = __webpack_public_path__ + "img/870-08309f.png";